export const fromSeconds = (sec: number) => sec * 1000;

export const fromMinutes = (min: number) => fromSeconds(min) * 60;

export const fromHours = (hour: number) => fromMinutes(hour) * 60;

export const fromDays = (day: number) => fromHours(day) * 24;
